export default __webpack_public_path__ + "assets/inconstruction.c7f42f59.png";